// https://app.asana.com/1/1200157658488969/task/1208867243541315/comment/1213716433186223?focus=true start
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if ($(node).hasClass('flickity-viewport')) {
        var section = $(node).closest('section');
        if ($(section).hasClass('home-products') || $(section).hasClass('home-testimonials') || $(section).hasClass('home-blog')) {
          console.log(section[0])
          initBullets($(node));
        }
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

function initBullets(node) {
  const bullets = $('<div class="cb-bullets"></div>');
  var section = $(node).closest('section');
  $(section).append('<style class="cb-bullets-style"></style>');
  $(node).find('article').each(function(index, el){
    const bullet = $(`<div class="cb-bullet" data-bullet-index="${index}"></div>`);
    bullets.append(bullet);
    $(el).attr('data-carousel-slide-index', index);
    const selector = `section:has([data-carousel-slide-index="${index}"].is-selected) .cb-bullet[data-bullet-index="${index}"]`;
    const rule = 'background: #242424;';
    $(section).find('.cb-bullets-style').append((selector + ' {' + rule + '}'))
  });
  $(section).append(bullets);
  observer.disconnect();
}
// https://app.asana.com/1/1200157658488969/task/1208867243541315/comment/1213716433186223?focus=true end
addEventListener("DOMContentLoaded", (event) => { 
  var elem = document.querySelector('.grid');
  var msnry = new Masonry( elem, {
    // options
    itemSelector: '.grid-item',
    gutter: 10
  });
   Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
  }); 
});